import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {TabellaAlternativiTurniRecord} from "@commons/mapping/TabellaAlternativiTurniRecord";
import {ObjectFactory} from "@commons/types";

export interface TabellaAlternativiRecord extends URIAndTrace {
    idAziendaTabelle: number;
    idTabella: number;
    descrizione: string;
    turniAlternativi?: TabellaAlternativiTurniRecord[]
}

export class TabellaAlternativiRecord {
    static factory: ObjectFactory<TabellaAlternativiRecord> = (json?) => {
        return {
            idAziendaTabelle: (json && json.idAziendaTabelle) ? json.idAziendaTabelle : 0,
            idTabella: (json && json.idTabella) ? json.idTabella : 0,
            descrizione: (json && json.descrizione) ? json.descrizione : '',
            turniAlternativi: (json && json.turniAlternativi) ? json.turniAlternativi : [],
            URI: null,
        };
    }
}